/**
 * Frontend plan configuration — mirrors backend/src/config/plans.py
 * This is the single source of truth for plan info in the frontend.
 */
import type { SubscriptionPlan } from '../types';
import { UNLIMITED } from '../utils/planLimits';

export interface PlanConfig {
  label: string;
  maxUsers: number;
  maxMonthlyExpenses: number | null; // null = unlimited (enterprise expenses)
  priceCLP: number;
  priceDisplay: string;
  maxAssetTypes: number;
  maxAssetsPerType: number;
  maxFieldsPerAssetType: number;
}

export const PLANS: Record<SubscriptionPlan, PlanConfig> = {
  starter: {
    label: 'Starter',
    maxUsers: 5,
    maxMonthlyExpenses: 1000,
    priceCLP: 99000,
    priceDisplay: '$99.000',
    maxAssetTypes: 5,
    maxAssetsPerType: 50,
    maxFieldsPerAssetType: 5,
  },
  business: {
    label: 'Business',
    maxUsers: 20,
    maxMonthlyExpenses: 5000,
    priceCLP: 179000,
    priceDisplay: '$179.000',
    maxAssetTypes: 10,
    maxAssetsPerType: 500,
    maxFieldsPerAssetType: 10,
  },
  enterprise: {
    label: 'Enterprise',
    maxUsers: UNLIMITED,
    maxMonthlyExpenses: null,
    priceCLP: 390000,
    priceDisplay: '$390.000',
    maxAssetTypes: UNLIMITED,
    maxAssetsPerType: UNLIMITED,
    maxFieldsPerAssetType: 20,
  },
};

/** Format user limit for display */
export function formatUsersDisplay(plan: SubscriptionPlan): string {
  const config = PLANS[plan];
  return config.maxUsers === UNLIMITED ? 'Ilimitado' : `${config.maxUsers}`;
}

/** Format expenses limit for display */
export function formatExpensesDisplay(plan: SubscriptionPlan): string {
  const config = PLANS[plan];
  return config.maxMonthlyExpenses === null
    ? 'Ilimitado'
    : config.maxMonthlyExpenses.toLocaleString('es-CL');
}
